// Plays the "chalk erase sweep" animation across the screen on each route
// change. Pure CSS — we just toggle a `.chalk-erase-reveal` class on a
// stable element (App root) keyed by pathname so the ::after pseudo
// re-runs whenever the user navigates.
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function useChalkEraseReveal() {
  const { pathname } = useLocation();
  const [armed, setArmed] = useState(false);

  useEffect(() => {
    // Skip the very first render so we don't paint over the initial paint.
    if (typeof window === "undefined") return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    setArmed(true);
    // The CSS animation is 0.55s. Disarm shortly after so the layer stops
    // intercepting any clicks (it's pointer-events: none anyway, but this
    // also keeps the DOM clean).
    const t = setTimeout(() => setArmed(false), 600);
    return () => clearTimeout(t);
  }, [pathname]);

  return armed ? "chalk-erase-reveal" : "";
}
